module.exports = __webpack_public_path__ + "static/media/10.a909ff0e.gif";